// ------------------------------------------------------------------------------
// name: error
// author: mudas
// created: 2024-11-20
// ------------------------------------------------------------------------------

/**
 * 是否通过 AbortController 取消请求后的错误对象
 * @param error
 */
export const isCanceledError = (error: Error) => {
  return (
    error['__CANCEL__'] ||
    error['code'] === 'ERR_CANCELED' ||
    error.name === 'CanceledError' ||
    /canceled/i.test(error.stack ?? '')
  );
};
